const React = require("react");
const noop = require("mn-utils/noop");
const DashboardBlockField = require("../../DashboardBlockField");
const withState = require("../../../../../../../utils/withState");
const Ripple = require("../../../../../../dumb/Ripple");
const CopyIcon = require("../../../../../../icons/Copy");
const copyTextToClipboard = require("mn-utils/browser/copyTextToClipboard");

module.exports = withState((setState, self, onMount) => {
  let timeout = noop;

  const onCopy = () => {
    copyTextToClipboard(self.props.value);
    setState({copied: true});
    timeout = setTimeout(() => setState({copied: false}), 2000);
  }

  onMount(() => {
    return () => clearTimeout(timeout);
  });

  return ({copied}, {label, value}) => {
    return (
      <DashboardBlockField
        label={label}
      >
        <div className="w h30 rlv ph10 layoutRow jcSB aiC">
          <span className="w100%-26 tovEllipsis ovHidden wsNowrap">
            {value || '-'}
          </span>
          <Ripple className="ml12" onClick={value ? onCopy : noop} disabled={!value}>
            <CopyIcon className="w14" />
          </Ripple>
          <div className={`
            w h abs st0 sl0 layoutRow aiC ph10 bgF.95 o0 z-1
            tn_all_0.25s_ease_0s dn r9 o100.active z5.active`
            + (copied ? ' active' : '')
          }>
            You have copied this value
          </div>
        </div>
      </DashboardBlockField>
    );
  }
});
